import React from 'react';

export const CoinsIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden {...props}>
    <ellipse cx="9" cy="8" rx="6" ry="2.5" stroke="currentColor" strokeWidth="1.75" />
    <path
      d="M3 8v5c0 1.38 2.69 2.5 6 2.5s6-1.12 6-2.5V8"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinejoin="round"
    />
    <ellipse cx="15" cy="13" rx="6" ry="2.5" stroke="currentColor" strokeWidth="1.75" />
    <path
      d="M9 13v5c0 1.38 2.69 2.5 6 2.5s6-1.12 6-2.5v-5"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinejoin="round"
    />
  </svg>
);
